/* eslint-disable no-console */

export default {
  TextoLogitudMaxima(textoEntrada, longitudMaxima) {
    if (textoEntrada.length < longitudMaxima) {
      return textoEntrada;
    }
    if (textoEntrada.length < (longitudMaxima - 3)) {
      return textoEntrada;
    }

    const longitud = longitudMaxima - 3;

    return `${textoEntrada.substr(0, longitud)}...`;
  },

  EliminarCaracteresContenidosEnUnaCadena(textoEntrada, caracterEliminar) {
    try {
      console.log('HiChainSupport->EliminarCaracteresContenidosEnUnaCadena');
      return this.ReemplazarCaracteresContenidosEnUnaCadena(textoEntrada, caracterEliminar, '');
    } catch (e) {
      console.error(`ERROR->SoporteNumeracion->EliminarCaracteresContenidosEnUnaCadena->${e}`);
      return textoEntrada;
    }
  },

  ReemplazarCaracteresContenidosEnUnaCadena(textoEntrada, textoReemplazar, textoReemplazo) {
    try {
      let textoSalida = '';
      return textoEntrada; // TODO Finalizar.

      // eslint-disable-next-line no-unreachable
      while (textoEntrada.toString().includes(textoReemplazar)) {
        textoSalida = textoEntrada.toString().replace(textoReemplazar, textoReemplazo);
      }
      // textoSalida = textoEntrada;
      return textoSalida;
    } catch (e) {
      console.error(`ERROR->SoporteNumeracion->ReemplazarCaracteresContenidosEnUnaCadena->${e}`);
      return textoEntrada;
    }
  },

  EliminarEspaciosEnBlancoContenidosEnUnaCadena(textoEntrada) {
    console.log('HiChainSupport->EliminarEspaciosEnBlancoContenidosEnUnaCadena');
    let textoSalida = '';
    textoSalida = textoEntrada.replace(' ', '');
    return textoSalida;
  },
};
